import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initGsapFullscreenTeamCards() {
    const sections = document.querySelectorAll('[data-gsap-team-cards]');

    sections.forEach(section => {
        const wrapper = section.querySelector('.team-cards-desktop-view .team-cards-track');
        const viewport = section.querySelector('.team-cards-desktop-view .team-cards-viewport');

        if (!wrapper || !viewport) return;

        // Use ResizeObserver to refresh ScrollTrigger when content changes
        const resizeObserver = new ResizeObserver(() => ScrollTrigger.refresh());
        resizeObserver.observe(wrapper);

        ScrollTrigger.matchMedia({
            "(min-width: 1500px) and (hover: hover)": function () {
                // Reset
                gsap.set(wrapper, { y: 0, clearProps: "all" });

                // Calculate distance
                const getScrollDistance = () => wrapper.offsetHeight - viewport.offsetHeight;

                ScrollTrigger.create({
                    trigger: section,
                    start: "top top",
                    end: () => {
                        const dist = getScrollDistance();
                        return `+=${Math.max(dist, window.innerHeight)}`;
                    },
                    pin: true,
                    pinSpacing: true,
                    scrub: true,
                    animation: gsap.to(wrapper, {
                        y: () => {
                            const dist = getScrollDistance();
                            return dist > 0 ? -dist : 0;
                        },
                        ease: "none"
                    })
                });
            },

            "(max-width: 1499px), (hover: none)": function () {
                // Reset for mobile/tablet/laptop
                gsap.set(wrapper, { y: 0, clearProps: "all" });
                gsap.set(section, { height: "auto", minHeight: "100vh", clearProps: "all" });

                // Reveal animation for grid items
                const revealItems = section.querySelectorAll('.js-team-card-reveal');
                revealItems.forEach(item => {
                    gsap.fromTo(item,
                        {
                            y: 50,
                            autoAlpha: 0
                        },
                        {
                            y: 0,
                            autoAlpha: 1,
                            duration: 1,
                            ease: "power2.out",
                            scrollTrigger: {
                                trigger: item,
                                start: "top 90%",
                                toggleActions: "play none none none"
                            }
                        }
                    );
                });
            }
        });
    });
}
